import { Component, OnInit } from '@angular/core';

@Component({
  selector: 's18-match-play',
  templateUrl: './match-play.component.html',
  styleUrls: ['./match-play.component.scss']
})
export class MatchPlayComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
